import { render, staticRenderFns } from "./modeSelect.vue?vue&type=template&id=efe4e4d2&scoped=true&"
import script from "./modeSelect.vue?vue&type=script&lang=js&"
export * from "./modeSelect.vue?vue&type=script&lang=js&"
import style0 from "./modeSelect.vue?vue&type=style&index=0&id=efe4e4d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe4e4d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efe4e4d2')) {
      api.createRecord('efe4e4d2', component.options)
    } else {
      api.reload('efe4e4d2', component.options)
    }
    module.hot.accept("./modeSelect.vue?vue&type=template&id=efe4e4d2&scoped=true&", function () {
      api.rerender('efe4e4d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/modeSelect.vue"
export default component.exports